/**
 * Asynchronously loads the component for StepperComponent
 */

import { lazyLoad } from 'utils/loadable';
import LoadingIndicator from 'app/components/LoadingIndicator';

export const StepperComponent = lazyLoad(
  () => import('./index'),
  module => module.StepperComponent,
  { fallback: <LoadingIndicator /> },
);
